module.exports = __webpack_public_path__ + "img/20110201_05.c3ed7fbb.jpg";